import { httpClient, postProcessUpsert } from "@genai/http-client";
import { AssistantId, EditAssistantForm } from "../model";

export function editAssistant(
  assistantId: AssistantId,
  editAssistantForm: EditAssistantForm,
) {
  return httpClient(`/assistants/${assistantId}`, {
    method: "PUT",
    body: JSON.stringify(editAssistantForm),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(postProcessUpsert);
}
